import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../..';
import { requestSectionAnalysis } from './api';

export interface ILectureAnalysisState {
  status: 'idle' | 'loading' | 'rejected';
  requestAnalysis?: boolean;
  sectionId?: string;
}

const initialState: ILectureAnalysisState = {
  status: 'idle',
  requestAnalysis: undefined,
  sectionId: undefined,
};

export const LectureAnalysisSlice = createSlice({
  name: 'lectureAnalysis',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestSectionAnalysis.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(requestSectionAnalysis.fulfilled, (state, action) => {
        state.status = 'idle';
        if (action.payload?.requestAnalysis !== undefined) {
          state.requestAnalysis = action.payload.requestAnalysis;
        }
        if (action.payload?.sectionId) {
          state.sectionId = action.payload.sectionId;
        }
      })
      .addCase(requestSectionAnalysis.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getLectureAnalysisState = (
  state: RootState
): RootState['lectureAnalysis'] => state.lectureAnalysis;

export * from './api';
export default LectureAnalysisSlice.reducer;
